import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { ModalComponent } from 'new/routes/RouterManager';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { TextField } from 'new/elements/TextField';
import { useForm } from 'react-hook-form';
import { UseFormProps } from 'react-hook-form/dist/types';
import { ServiceKeyPayload } from 'new/components/settings/Authentication/ServiceKeys/useServiceKey';
import { useModals } from 'new/hooks/useModals';

type InputKeys = 'name' | 'description';
const useFormInitialProps = {
  mode: 'onChange',
  reValidateMode: 'onChange',
  defaultValues: { name: '', description: '' },
} as UseFormProps<any>;

type Props = ModalOutProps & {
  createServiceKey(data: ServiceKeyPayload): Promise<void>;
};

export const CreateServiceKeyModal: ModalComponent = (props: Props) => {
  const modal = useModals();
  const { setModalActions } = props;

  const {
    watch,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm(useFormInitialProps);
  const name = watch().name;

  const onSubmit = async () => {
    try {
      await props.createServiceKey(getValues());
      modal.closeModal(CreateServiceKeyModal.modalConfig.name);
    } catch (e) {
      console.error('CreateServiceKeyModal.onSubmit', e.message);
    }
  };

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Create',
        onClick: onSubmit,
        disabled: Object.keys(errors || {}).length > 0 || name === '',
      },
    });
  }, [name, errors]);

  const getRegister = (key: InputKeys) => ({
    ...register(key, { required: `You need to set a ${key}` }),
  });

  const getErrorMessage = (key: InputKeys) => (errors[key] ? errors[key]?.message : undefined);

  return (
    <Stack flexDirection="column" gap="16px" minWidth="400px">
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
      >
        <TextField
          label="Name"
          error={!!errors.name}
          helperText={getErrorMessage('name')}
          {...getRegister('name')}
        />

        <TextField label="Description" {...getRegister('description')} />
      </form>
    </Stack>
  );
};

CreateServiceKeyModal.modalConfig = {
  name: 'CreateServiceKeyModal',
  maxWidth: 'md',
  title: 'Create a new Service Key',
};
